var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon-arrow-up",attrs:{"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 2.808l8 8-2.383 2.385-5.617-5.617-5.617 5.617-2.382-2.385z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }